import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Informes/editSeleccionInformePersonalizado`, method: 'POST', body: values, token: token})
}